import Vue from 'vue'
import Vuex from 'vuex'
import authModule from './modules/auth'
import productModule from './modules/product'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth: authModule,
    product: productModule
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js